import type { QueryClient } from '@tanstack/react-query';
import { CustomCodeScope } from '../../endpoints/custom-codes';

export type { CustomCodeScope };

/** One list per scope; the segment names keep the two scopes from colliding. */
export const customCodesQueryKey = (scope: CustomCodeScope) =>
  'organizationId' in scope
    ? (['custom-codes', 'organization', scope.organizationId] as const)
    : (['custom-codes', 'landing-page', scope.landingPageId] as const);

// A custom-code mutation synchronously flips the affected current versions'
// packagingStatus back to `packaging` and re-packages the artifacts in the
// background. Refetching campaigns immediately therefore never races the
// worker: open studios see the flip and poll until `packagedAt` changes —
// the "re-package landed" signal that cache-busts the preview URLs.
export const invalidatePackagedPreviews = (queryClient: QueryClient) => {
  void queryClient.invalidateQueries({ queryKey: ['campaign'] });
};
